import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import ReactDataTable from "react-data-table-component";
import { UserServiceContext } from "../services/user/userService";
import Loader from "../components/Loader";
import CustomAlert from "../components/CustomAlert";
import { paginationComponentOptions } from "../utils/constants";
import BreadcrumbBack from "../components/common/BreadcrumbBack";
import { IconUserPlus, IconTrash, IconEdit, IconCheck } from "@tabler/icons-react";
import ContactHeader from "../components/common/ContactHeader";
import NewAddressContactModal from "./app/modals/NewAddressContactModal";

const NewAddressContacts = () => {
  const { id } = useParams();
  const {
    loading,
    getUserFavoriteClientById,
    userFavoriteContactDeactivate,
    getCities,
    cities,
    userFavoriteContactSetAsDefault
  } = useContext(UserServiceContext);

  const [showAddressModal, setShowAddressModal] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [contact, setContact] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [updatedCities, setUpdatedCities] = useState([]);
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    text: "",
    icon: "",
    onConfirm: null,
    onCancel: null,
  });

  const fetchContacts = async () => {
    const response = await getUserFavoriteClientById(id);
    if (response && response.data.success) {
      //console.log(response.data.clientAddress[0].contacts);
      let data = response.data.clientAddress[0];
      setContact(data);
      setContacts(data.contacts);

      //setContacts(response.data.clientAddress[0].contacts);
    }
  };

  const fetchCities = async () => {
    await getCities();
  };

  useEffect(() => {
    if (id) {
      fetchContacts(id);
    }
  }, [id]);

  useEffect(() => {
    fetchCities();
  }, []);

  useEffect(() => {
    if (cities && cities.length > 0) {
      //console.log(cities);
      const updatedData = cities.map(({ value, ...rest }) => ({
        name: value,
        ...rest,
      }));
      setUpdatedCities(updatedData);
    }
  }, [cities]);

  const handleModalShow = (changed) => {
    setShowAddressModal(!showAddressModal);
    if (!changed) return;
    fetchContacts();
  };


  const handleMakeDefault = async (row) => {
    await userFavoriteContactSetAsDefault(row.id);
    await fetchContacts();
  }

  const handleEditClick = (row, edit) => {
    setContact(row);
    setIsEdit(edit);
    setShowAddressModal(true);
  };

  const handleDeleteContact = (row) => {
    setAlertConfig({
      show: true,
      title: "დარწმუნებული ხართ?",
      text: "გსურთ ამ კონტაქტის წაშლა?",
      icon: "warning",
      showConfirmButton: true,
      onConfirm: async () => {
        await userFavoriteContactDeactivate(row.id);
        setAlertConfig({ ...alertConfig, show: false });
        fetchContacts();
      },
      onCancel: () => {
        setAlertConfig({ ...alertConfig, show: false });
      },
    });
  };

  const columns = [
    {
      name: "სახელი",
      selector: (row) => row.name,
    },
    { name: "ტელეფონი", selector: (row) => row.contactPhone },
    { name: "მისამართი", selector: (row) => row.address },
    {
      name: "ქალაქი",
      selector: (row) => {
        return cities.find((city) => city.id === row.cityId)?.value || "";
      },
    },
    {
      cell: (row) => (
        contact.isDefault && !row.isDefault && (
          <button
            className="btn btn-outline-secondary"
            onClick={() => handleMakeDefault(row)}
            title="საწყისად გახდა"
          >
            <IconCheck className="w-[18px] h-[18px]" />
          </button>)
      ),
      width: "60px"
    },
    {
      cell: (row) => (
        <button
          className="btn btn-outline-secondary"
          onClick={() => handleEditClick(row, true)}
          title="შესწორება"
        >
          <IconEdit className="w-[18px] h-[18px]" />
        </button>
      ),
      width: "60px"
    },
    {
      cell: (row) => (
        !row.isDefault && (<button
          className="btn btn-outline-secondary"
          onClick={() => handleDeleteContact(row)}
          title="წაშლა"
        >
          <IconTrash className="w-[18px] h-[18px]" />
        </button>)
      ),
      width: "65px"
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.isDefault == true,
      classNames: ['text-danger'],
      style: {
        // backgroundColor: "#f3fff4!important",
        color: "#2e7d32!important",

      }
    }
  ];


  return (
    <>
      {loading && <Loader />}
      <CustomAlert {...alertConfig} />
      {showAddressModal && (
        <NewAddressContactModal
          show={showAddressModal}
          setCreateEventModal={handleModalShow}
          isEdit={isEdit}
          contact={contact}
          cities={updatedCities}
          id={id}
        />
      )}
      <div className="mx-20 my-20">
        <BreadcrumbBack backUrl={"/account-addresses"} />
        <div className="flex md:items-center md:justify-between md:flex-row flex-col gap-15">
          <ContactHeader data={contact} />
          <button
            className="btn btn-outline-secondary"
            onClick={() => handleEditClick({}, false)}
          >
            <IconUserPlus className="w-[18px] h-[18px]" />
            <span className="sm:block hidden">დამატება</span>
          </button>
        </div>
        <div className="flex items-stretch justify-end gap-1 flex-wrap mb-20"></div>
        <div className="react-data-table">
          <ReactDataTable
            columns={columns}
            data={contacts}
            striped
            pagination
            conditionalRowStyles={conditionalRowStyles}
            paginationComponentOptions={paginationComponentOptions}
            noDataComponent={
              <div
                style={{
                  textAlign: "center",
                  padding: "20px",
                  color: "gray",
                }}
              >
                საკონტაქტო პირები დამატებული არ გყავთ
              </div>
            }
          />
        </div>
      </div>
    </>
  );
};

export default NewAddressContacts;
